var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAskHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.456 62.9559C84.656 62.9559 82.206 64.0059 80.106 66.1059L78.706 67.8559L77.306 66.1059C75.206 64.0059 72.406 62.9559 69.956 62.9559C67.506 62.9559 64.706 64.0059 62.606 66.1059C58.406 70.3059 58.406 76.9559 62.606 81.1559L78.706 97.9559L94.806 81.1559C99.006 76.9559 99.006 70.3059 94.806 66.1059C93.056 64.0059 90.256 62.9559 87.456 62.9559Z",
    fill: "#228AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1 93.1L7 49L49 7L93.1 51.1L98 46.2L54.25 2.1C51.45 -0.7 46.9 -0.7 44.1 2.1L2.1 43.75C-0.7 46.55 -0.7 51.1 2.1 53.9L45.85 98L51.1 93.1Z",
    fill: "#228AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskHelp);
export default __webpack_public_path__ + "static/media/askHelp.53030c37f1396ea45cf7ae165f7f4803.svg";
export { ForwardRef as ReactComponent };